export const ApiEndpointKey = {
  // Core / Shared
  BD_PERMISSION_RESOURCE_URL: 'BD_PERMISSION_RESOURCE_URL',
  BD_FILES_RESOURCE_URL: 'BD_FILES_RESOURCE_URL',
  BD_JOBS_RESOURCE_URL: 'BD_JOBS_RESOURCE_URL',
  BD_DISTRICT_URL: 'BD_DISTRICT_URL',
  BD_AI_API_URL: 'BD_AI_API_URL',

  // Analytics
  AYS_CODE_URL: 'AYS_CODE_URL',
  AYS_RESOURCE_URL: 'AYS_RESOURCE_URL',
  AYS_CLINIC_RESOURCE_URL: 'AYS_CLINIC_RESOURCE_URL',
  AYS_CLINIC_EXPORT_URL: 'AYS_CLINIC_EXPORT_URL',
  // BDA-5849 (401 fix). The annual-account sub-route requires an authenticated
  // caller, unlike its sibling clinic-detail sections (overview, case-numbers,
  // ...), which stay reachable under the anonymous AYS_CLINIC_RESOURCE_URL
  // base. No service ever loads this URL as a request base — it exists only
  // so its path pattern lands in MSAL's protectedResourceMap. See
  // app-config.ts for the wildcard-carrying value.
  AYS_CLINIC_ANNUAL_ACCOUNT_URL: 'AYS_CLINIC_ANNUAL_ACCOUNT_URL',
  AYS_CLINIC_FILTER_STORAGE_URL: 'AYS_CLINIC_FILTER_STORAGE_URL',
  // BDA-5849 — the Klinik-Cube. Served by clinics-api alongside /api/clinics,
  // under the epic's original working name: /api/kennzahlen-benchmarking.
  AYS_CLINICS_CUBE_URL: 'AYS_CLINICS_CUBE_URL',
  AYS_CODE_SPECTRUM_STORAGE_URL: 'AYS_CODE_SPECTRUM_STORAGE_URL',
  AYS_COMPETITORS_ANALYSIS_RESOURCE_URL: 'AYS_COMPETITORS_ANALYSIS_RESOURCE_URL',
  AYS_COMPETITORS_ANALYSIS_CALCULATION_URL: 'AYS_COMPETITORS_ANALYSIS_CALCULATION_URL',
  AYS_DEMAND_ANALYSIS_URL: 'AYS_DEMAND_ANALYSIS_URL',
  AYS_FAB_RESOURCE_URL: 'AYS_FAB_RESOURCE_URL',
  AYS_MARKET_STORAGE_URL: 'AYS_MARKET_STORAGE_URL',
  AYS_POTENTIAL_URL: 'AYS_POTENTIAL_URL',
  AYS_PROJECTION_RESOURCE_URL: 'AYS_PROJECTION_RESOURCE_URL',
  AYS_SCENARIO_ANALYSIS_RESOURCE_URL: 'AYS_SCENARIO_ANALYSIS_RESOURCE_URL',
  AYS_BENCHMARKING_GROUP_RESOURCE_URL: 'AYS_BENCHMARKING_GROUP_RESOURCE_URL',

  // Virtual Clinic
  AYS_VIRTUAL_CLINIC_RESOURCE_URL: 'AYS_VIRTUAL_CLINIC_RESOURCE_URL',
  AYS_VIRTUAL_CLINIC_REFERRAL_RESOURCE_URL: 'AYS_VIRTUAL_CLINIC_REFERRAL_RESOURCE_URL',
  AYS_VIRTUAL_CLINIC_REFERRAL_IMPORT_RESOURCE_URL: 'AYS_VIRTUAL_CLINIC_REFERRAL_IMPORT_RESOURCE_URL',
  AYS_VIRTUAL_CLINIC_P21_IMPORT_RESOURCE_URL: 'AYS_VIRTUAL_CLINIC_P21_IMPORT_RESOURCE_URL',

  // Business
  BD_BUSINESS_CASE_RESOURCE_URL: 'BD_BUSINESS_CASE_RESOURCE_URL',
  BMG_DEMAND_ANALYSIS_URL: 'BMG_DEMAND_ANALYSIS_URL',
  CUBE_DASHBOARD_URL: 'CUBE_DASHBOARD_URL',
  DRG_PROFIT_LOSS_ANALYSIS_RESOURCE_URL: 'DRG_PROFIT_LOSS_ANALYSIS_RESOURCE_URL',

  // Content
  INTUITIVE_PP_EXPORTS_API: 'INTUITIVE_PP_EXPORTS_API',

  // Country-specific
  AT_CODE_SPECTRUM_API_URL: 'AT_CODE_SPECTRUM_API_URL',
  AT_CUBE_DASHBOARD_API_URL: 'AT_CUBE_DASHBOARD_API_URL',
  AT_VIRTUAL_CLINIC_API_URL: 'AT_VIRTUAL_CLINIC_API_URL',
  CH_CODE_API_URL: 'CH_CODE_API_URL',
  CH_CODE_SPECTRUM_API_URL: 'CH_CODE_SPECTRUM_API_URL',
  CH_CUBE_DASHBOARD_API_URL: 'CH_CUBE_DASHBOARD_API_URL',
  CH_VIRTUAL_CLINIC_API_URL: 'CH_VIRTUAL_CLINIC_API_URL',
  UK_CODE_SPECTRUM_API_URL: 'UK_CODE_SPECTRUM_API_URL',

  // App URLs used as endpoints
  AYS_CLINIC_CASE_COUNT_URL: 'AYS_CLINIC_CASE_COUNT_URL',
  KOST_DATA_IMPORT_AT_APP: 'KOST_DATA_IMPORT_AT_APP',
  KOST_DATA_IMPORT_CH_APP: 'KOST_DATA_IMPORT_CH_APP',
} as const;

export type ApiEndpointKeyType = typeof ApiEndpointKey[keyof typeof ApiEndpointKey];
